(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aware-benefit-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aware-benefit-carousel')) {
    class AwareBenefitCarousel extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        this.controller?.abort();
      }

      setup() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.viewport = this.querySelector('.aware-benefit-slider__viewport');
        this.items = [...this.querySelectorAll('.aware-benefit-slider__item')];
        this.dots = [...this.querySelectorAll('.aware-benefit-slider__dot')];

        if (!this.viewport || !this.items.length) return;

        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hovered = false;
        this.pressed = false;
        this.drag = null;
        this.updateCurrent();

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index), { signal });
        });

        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          clearTimeout(this.settleTimer);

          this.settleTimer = setTimeout(() => {
            this.updateCurrent();
            this.schedule();
          }, 150);
        }, { passive: true, signal });

        this.viewport.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          this.updateCurrent();

          const rtl = getComputedStyle(this.viewport).direction === 'rtl';
          let next = this.index;

          if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = this.items.length - 1;
          } else {
            next += (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
          }

          this.goTo(next);
        }, { signal });

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          clearTimeout(this.timer);
        }, { signal });

        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.schedule();
        }, { signal });

        this.addEventListener('focusin', () => {
          clearTimeout(this.timer);
        }, { signal });

        this.addEventListener('focusout', () => {
          queueMicrotask(() => this.schedule());
        }, { signal });

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;

          this.pressed = true;
          clearTimeout(this.timer);

          if (event.pointerType === 'mouse') {
            this.drag = {
              id: event.pointerId,
              x: event.clientX,
              left: this.viewport.scrollLeft
            };

            this.viewport.setPointerCapture(event.pointerId);
            this.viewport.classList.add('is-dragging');
          }
        }, { signal });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;

          event.preventDefault();
          this.viewport.scrollLeft =
            this.drag.left - (event.clientX - this.drag.x);
        }, { signal });

        const release = () => {
          this.pressed = false;

          if (this.drag) {
            this.drag = null;
            this.viewport.classList.remove('is-dragging');
            this.updateCurrent();
            this.goTo(this.index);
          }

          this.schedule();
        };

        this.viewport.addEventListener('pointerup', release, { signal });
        this.viewport.addEventListener('pointercancel', release, { signal });
        this.viewport.addEventListener('lostpointercapture', release, { signal });

        this.viewport.addEventListener('wheel', () => {
          this.schedule();
        }, { passive: true, signal });

        document.addEventListener('visibilitychange', () => {
          this.schedule();
        }, { signal });

        this.motion.addEventListener('change', () => {
          this.schedule();
        }, { signal });

        this.schedule();
      }

      updateCurrent() {
        const left = this.viewport.getBoundingClientRect().left;
        let nearest = Infinity;
        this.index = 0;

        this.items.forEach((item, index) => {
          const distance = Math.abs(
            item.getBoundingClientRect().left - left
          );

          if (distance < nearest) {
            nearest = distance;
            this.index = index;
          }
        });

        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === this.index));
        });
      }

      goTo(index) {
        clearTimeout(this.timer);

        const next = (index + this.items.length) % this.items.length;
        const offset =
          this.items[next].getBoundingClientRect().left -
          this.viewport.getBoundingClientRect().left;

        this.viewport.scrollTo({
          left: this.viewport.scrollLeft + offset,
          behavior:
            this.motion.matches || Math.abs(next - this.index) > 1
              ? 'auto'
              : 'smooth'
        });

        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);

        if (
          !this.isConnected ||
          this.dataset.autoplay !== 'true' ||
          this.items.length < 2
        ) return;

        if (
          this.motion.matches ||
          document.hidden ||
          this.hovered ||
          this.pressed ||
          this.contains(document.activeElement)
        ) return;

        this.timer = setTimeout(() => {
          this.updateCurrent();
          this.goTo(this.index + 1);
        }, Number(this.dataset.interval) || 4000);
      }
    }

    customElements.define('aware-benefit-carousel', AwareBenefitCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aware-product-irl-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aware-irl-gallery')) {
    customElements.define('aware-irl-gallery', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.aware-irl__gallery');
        if (!this.scroller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.updateButtons = () => {
          const maximum = this.scroller.scrollWidth - this.scroller.clientWidth;
          this.querySelectorAll('[data-irl-direction]').forEach(button => {
            button.disabled = Number(button.dataset.irlDirection) < 0
              ? this.scroller.scrollLeft <= 2
              : this.scroller.scrollLeft >= maximum - 2;
          });
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-irl-direction]');
          if (!button || button.disabled || !this.contains(button)) return;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scroller.scrollBy({
            left: Number(button.dataset.irlDirection) * (this.scroller.clientWidth + 12),
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }, { signal });
        this.scroller.addEventListener('scroll', this.updateButtons, { passive: true, signal });
        this.observer = new ResizeObserver(this.updateButtons);
        this.observer.observe(this.scroller);
        this.updateButtons();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
